import cn from 'classnames';

interface IValueInfoProps {
  title: string;
  value: string | number;
  valueUnit?: string;
  titleWidth?: string;
  valueUnitClassName?: string;
}

const ValueInfo = ({
  title,
  value,
  valueUnit,
  titleWidth = '4rem',
  valueUnitClassName,
}: IValueInfoProps) => {
  if (value === null || value === undefined) return null;

  return (
    <div
      className="grid w-full min-w-0 grid-cols-[minmax(0,1fr)_minmax(0,1fr)] items-center gap-1.5"
      style={{
        gridTemplateColumns: `${titleWidth} minmax(0, 1fr)`,
      }}
    >
      <span className="text-sm text-gray-600">{title}</span>

      <div className="flex items-center min-w-0">
        <span
          className="min-w-0 overflow-hidden text-gray-900 text-ellipsis whitespace-nowrap text-md font-Medium"
          title={String(value)}
        >
          {value}
        </span>

        {value && value !== '0' && valueUnit && (
          <span
            className={cn(
              'mr-1 text-sm text-gray-600 shrink-0',
              valueUnitClassName,
            )}
          >
            {valueUnit}
          </span>
        )}
      </div>
    </div>
  );
};

export default ValueInfo;
